import { createReducer } from '@reduxjs/toolkit'
import {
  showItemList,
  setItemList,
  updateTakeOffCalculation,
  selectAreas,
  deselectAreas,
  setIsTakeOffCalculationInProgress,
} from '../actions/takeOff'
import { TakeOffItem, TakeOffCalculation } from '../models/TakeOff'

const takeOffItemsMock: TakeOffItem[] = [
  {
    parentGroup: 'Electrical',
    unitName: 'Ev Charger',
    brand: 'UNIFI',
    modelLinkName: 'UC-EV-Station-Pro',
    quantity: 2.0,
    unitCost: 1199.0,
    totalCost: 2398.0,
    modelLink:
      'https://store.ui.com/us/en/category/ev-charging/products/uc-ev-station-pro',
  },
  {
    parentGroup: 'Electrical',
    unitName: '20 Amp Tamper Resistant Duplex',
    brand: 'Leviton',
    modelLinkName: 'R52-T5825-00W',
    quantity: 80.0,
    unitCost: 7.48,
    totalCost: 598.4000000000001,
    modelLink:
      'https://www.homedepot.com/p/Leviton-Decora-20-Amp-125-V-Tamper-Resistant-Duplex-Outlet-Receptacle-White-1-Pack-T5825-00W-R52-T5825-00W/203245679',
  },
  {
    parentGroup: 'Electrical',
    unitName: '20 Amp AFCI/GFCI Dual Function Outlet',
    brand: 'Leviton',
    modelLinkName: 'R02-AGTR2-0KW',
    quantity: 28.0,
    unitCost: 32.1,
    totalCost: 898.8000000000001,
    modelLink:
      'https://www.homedepot.com/p/Leviton-20-Amp-125-Volt-Duplex-Self-Test-SmartlockPro-Tamper-Resistant-AFCI-GFCI-Dual-Function-Outlet-White-R02-AGTR2-0KW/310385809',
  },
  {
    parentGroup: 'Electrical',
    unitName: 'Wall Plate',
    brand: 'Leviton',
    modelLinkName: 'V04-0PJ26-H4W',
    quantity: 148.0,
    unitCost: 0.87,
    totalCost: 128.76,
    modelLink:
      'https://www.homedepot.com/p/Leviton-1-Gang-White-Decora-Rocker-Nylon-Midway-Midsize-Wall-Plate-4-Pack-0PJ26-H4W-V04-0PJ26-H4W/313936201?MERCH=REC-_-brand_based_collection-_-310385809-_-1-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a',
  },
  {
    parentGroup: 'Electrical',
    unitName: '20 Amp Light Switch',
    brand: 'Leviton',
    modelLinkName: 'M32-05601-2WM',
    quantity: 40.0,
    unitCost: 2.22,
    totalCost: 88.80000000000001,
    modelLink:
      'https://www.homedepot.com/p/Leviton-Decora-15-Amp-Single-Pole-Rocker-AC-Quiet-Light-Switch-White-10-Pack-M32-05601-2WM/202204204?MERCH=REC-_-fbt_test-_-310385809-_-2-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a',
  },
  {
    parentGroup: 'Electrical',
    unitName: 'Weatherproof In-Use Cover',
    brand: 'Commercial Electric',
    modelLinkName: 'WCW1PC',
    quantity: 10.0,
    unitCost: 10.48,
    totalCost: 104.80000000000001,
    modelLink:
      'https://www.homedepot.com/p/Commercial-Electric-1-Gang-Extra-Duty-Horizontal-Vertical-Non-Metallic-Weatherproof-In-Use-Cover-16-in-1-Configurations-Clear-WCW1PC/300849073?MERCH=REC-_-fbt_test-_-310385809-_-4-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a',
  },
  {
    parentGroup: 'Electrical',
    unitName:
      'RS 1 - 3 in. Aluminum Recessed Lighting Housing for New Construction Shallow Ceiling',
    brand: 'Halo',
    modelLinkName: 'H36ICAT+3003WHWB',
    quantity: 28.0,
    unitCost: 102.0,
    totalCost: 2856.0,
    modelLink:
      'https://www.homedepot.com/p/HALO-3-in-White-Recessed-Ceiling-Light-Adjustable-Baffle-Trim-3003WHWB/203009453?MERCH=REC-_-brand_based_collection-_-206792239-_-1-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a',
  },
  {
    parentGroup: 'Electrical',
    unitName:
      'RS 3 - 6 in. Steel Recessed Lighting Housing for New Construction ',
    brand: 'Halo',
    modelLinkName: 'H99TAT + 993W',
    quantity: 125.0,
    unitCost: 36.79,
    totalCost: 4598.75,
    modelLink:
      'https://www.homedepot.com/p/HALO-993-Series-4-in-White-Recessed-Ceiling-Light-Fixture-Trim-with-Baffle-993W/203655358?MERCH=REC-_-irgaccessories-_-202827238-_-0-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a',
  },
  {
    parentGroup: 'Electrical',
    unitName:
      'RS 2 - 4 in. Steel Recessed Lighting Housing for New Construction ',
    brand: 'Halo',
    modelLinkName: 'H7ICAT+ 310w',
    quantity: 24.0,
    unitCost: 34.97,
    totalCost: 839.28,
    modelLink:
      'https://www.homedepot.com/p/HALO-310-Series-6-in-White-Recessed-Ceiling-Light-Fixture-Trim-with-Coilex-Baffle-310W/303863889?MERCH=REC-_-brand_based_collection-_-202522896-_-3-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a',
  },
  {
    parentGroup: 'Electrical',
    unitName: 'Outdoor - Porch-Light Lantern Sconce',
    brand: 'Artika',
    modelLinkName: 'OUT-VS-MB',
    quantity: 10.0,
    unitCost: 109.0,
    totalCost: 1090.0,
    modelLink:
      'https://www.homedepot.com/p/Artika-Valor-Black-Modern-Square-Integrated-LED-Exterior-Hardwired-Garage-and-Porch-Light-Lantern-Sconce-OUT-VS-MB/322530560',
  },
  {
    parentGroup: 'Electrical',
    unitName: 'Monocrystalline Solar Panels PV Power Charger',
    brand: 'Renogy',
    modelLinkName: 'RSP550D-144x4-US',
    quantity: 20.0,
    unitCost: 547.1,
    totalCost: 10942.0,
    modelLink:
      'https://www.homedepot.com/p/Renogy-550-Watt-2000-Watt-12-24-Volt-Monocrystalline-Solar-Panels-PV-Power-Charger-On-Off-Grid-Supplies-for-Rooftop-4-Pieces-RSP550D-144x4-US/325922243?MERCH=REC-_-pipsem-_-314422122-_-1-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a',
  },
  {
    parentGroup: 'Electrical',
    unitName: '400 Amp 30-Space 40-Circuit Outdoor',
    brand: 'Square D',
    modelLinkName: 'SU3040D400CN',
    quantity: 1.0,
    unitCost: 1554.0,
    totalCost: 1554.0,
    modelLink:
      'https://www.homedepot.com/p/Square-D-Homeline-400-Amp-30-Space-40-Circuit-Outdoor-Ring-Type-Underground-Main-Breaker-CSED-with-Class-320-SU3040D400CN/100145556',
  },
  {
    parentGroup: 'Electrical',
    unitName: 'Homeline 200 Amp 40-Space 80-Circuit Panel',
    brand: 'Square D',
    modelLinkName: 'HOM4080M200PCVP',
    quantity: 1.0,
    unitCost: 249.0,
    totalCost: 249.0,
    modelLink:
      'https://www.homedepot.com/p/Square-D-Homeline-200-Amp-40-Space-80-Circuit-Panel-w-3-20-Amp-Single-Pole-2-30-Amp-Double-Pole-Breakers-Cover-Value-Pack-HOM4080M200PCVP/204836379',
  },
  {
    parentGroup: 'Electrical',
    unitName: '1000 ft. 12/2 Solid Romex SIMpull',
    brand: 'Southwire',
    modelLinkName: '28828201',
    quantity: 4.0,
    unitCost: 490.0,
    totalCost: 1960.0,
    modelLink:
      'https://www.homedepot.com/p/Southwire-1000-ft-12-2-Solid-Romex-SIMpull-CU-NM-B-W-G-Wire-28828201/202316226',
  },
  {
    parentGroup: 'Electrical',
    unitName:
      '1,000 ft. 14/3 Light Blue Solid CerroMax SLiPWire Copper NM-B Wire',
    brand: 'Cerrowire',
    modelLinkName: '147-14043K',
    quantity: 1.0,
    unitCost: 642.77,
    totalCost: 642.77,
    modelLink:
      'https://www.homedepot.com/p/Cerrowire-1-000-ft-14-3-Light-Blue-Solid-CerroMax-SLiPWire-Copper-NM-B-Wire-147-14043K/326094641',
  },
  {
    parentGroup: 'Electrical',
    unitName: '1000 ft. 8/3 Stranded Romex SIMpull CU NM-B W/G Wire',
    brand: 'Southwire',
    modelLinkName: '63949201',
    quantity: 1.0,
    unitCost: 2655.69,
    totalCost: 2655.69,
    modelLink:
      'https://www.homedepot.com/p/Southwire-1000-ft-8-3-Stranded-Romex-SIMpull-CU-NM-B-W-G-Wire-63949201/205919801',
  },
  {
    parentGroup: 'Electrical',
    unitName:
      '1000 ft. 10-Gauge/3 Solid Romex SIM pull CU NM-B with G Wire Pink Spool',
    brand: 'Southwire',
    modelLinkName: '63948501',
    quantity: 1.0,
    unitCost: 1299.0,
    totalCost: 1299.0,
    modelLink:
      'https://www.homedepot.com/p/Southwire-1000-ft-10-Gauge-3-Solid-Romex-SIM-pull-CU-NM-B-with-G-Wire-Pink-Spool-63948501/329918571',
  },
  {
    parentGroup: 'Electrical',
    unitName: '1000 ft. 12/3 Purple Solid CerroMax SLiPWire Copper NM-B Wire',
    brand: 'Cerrowire',
    modelLinkName: '147-16093K',
    quantity: 1.0,
    unitCost: 1059.91,
    totalCost: 1059.91,
    modelLink:
      'https://www.homedepot.com/p/Cerrowire-1000-ft-12-3-Purple-Solid-CerroMax-SLiPWire-Copper-NM-B-Wire-147-16093K/326094682',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '4 in. x 10 ft. ABS DWV Cell Core Pipe',
    brand: 'IPEX',
    modelLinkName: '179687',
    quantity: 1.0,
    unitCost: 4.0,
    totalCost: 1121.88,
    modelLink:
      'https://www.homedepot.com/p/IPEX-4-in-x-10-ft-ABS-DWV-Cell-Core-Pipe-179687/309282462',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '4 in. ABS DWV Hub x Hub Coupling',
    brand: 'Charlotte Pipe',
    modelLinkName: 'ABS001001200HD',
    quantity: 10.0,
    unitCost: 8.41,
    totalCost: 84.1,
    modelLink:
      'https://www.homedepot.com/p/Charlotte-Pipe-4-in-ABS-DWV-Hub-x-Hub-Coupling-ABS001001200HD/313834617?MERCH=REC-_-fbt_test-_-309282462-_-1-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '4 in. ABS 90-Degree Hub x Hub Elbow Fitting',
    brand: 'Charlotte Pipe',
    modelLinkName: 'ABS003001200HD',
    quantity: 4.0,
    unitCost: 20.96,
    totalCost: 83.84,
    modelLink:
      'https://www.homedepot.com/p/Charlotte-Pipe-4-in-x-4-Acrylonitrile-Butadiene-Styrene-ABS-DWV-90-Degree-Hub-x-Hub-Elbow-Fitting-ABS003001200HD/313834632?MERCH=REC-_-fbt_test-_-313834617-_-2-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '4 in. ABS DWV 22-1/2-Degree Hub x Spigot Elbow Fitting',
    brand: 'Charlotte Pipe',
    modelLinkName: 'ABS003261200HD',
    quantity: 13.0,
    unitCost: 27.67,
    totalCost: 359.71000000000004,
    modelLink:
      'https://www.homedepot.com/p/Charlotte-Pipe-4-in-ABS-DWV-22-1-2-Degree-Hub-x-Spigot-Elbow-Fitting-ABS003261200HD/313834687',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '4 in. ABS DWV MPT Cleanout Plug',
    brand: 'Charlotte Pipe',
    modelLinkName: 'ABS001061600HD',
    quantity: 5.0,
    unitCost: 11.21,
    totalCost: 56.050000000000004,
    modelLink:
      'https://www.homedepot.com/p/Charlotte-Pipe-4-in-ABS-DWV-MPT-Cleanout-Plug-ABS001061600HD/313834594?MERCH=REC-_-brand_based_collection-_-313834617-_-7-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '4 in. ABS DWV Long Sweep',
    brand: 'Charlotte Pipe',
    modelLinkName: 'ABS003041200HD',
    quantity: 6.0,
    unitCost: 34.93,
    totalCost: 209.57999999999998,
    modelLink:
      'https://www.homedepot.com/p/Charlotte-Pipe-4-in-ABS-DWV-Long-Sweep-ABS003041200HD/313834642',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '2 in. x 10 ft. ABS DWV Cell Core Pipe',
    brand: 'IPEX',
    modelLinkName: '179685',
    quantity: 15.0,
    unitCost: 1.53,
    totalCost: 3511.35,
    modelLink:
      'https://www.homedepot.com/p/IPEX-2-in-x-10-ft-ABS-DWV-Cell-Core-Pipe-179685/309282467',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '2 in. ABS DWV Hub x Hub Coupling',
    brand: 'Charlotte Pipe',
    modelLinkName: 'ABS001001200HD',
    quantity: 9.0,
    unitCost: 2.12,
    totalCost: 19.080000000000002,
    modelLink:
      'https://www.homedepot.com/p/Charlotte-Pipe-2-in-ABS-DW-Hub-x-Hub-Coupling-ABS001000800HD/313834620',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '2 in. ABS 90-Degree Hub x Hub Elbow Fitting',
    brand: 'Charlotte Pipe',
    modelLinkName: 'ABS003000800HD',
    quantity: 6.0,
    unitCost: 3.97,
    totalCost: 23.82,
    modelLink:
      'https://www.homedepot.com/p/Charlotte-Pipe-2-in-x-2-in-Acrylonitrile-Butadiene-Styrene-ABS-DWV-90-Degree-Hub-x-Hub-Elbow-Fitting-ABS003000800HD/313834630',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '2 in. ABS DWV 22-1/2-Degree Hub x Spigot Elbow Fitting',
    brand: 'Charlotte Pipe',
    modelLinkName: 'ABS003260800HD',
    quantity: 4.0,
    unitCost: 9.91,
    totalCost: 39.64,
    modelLink:
      'https://www.homedepot.com/p/Charlotte-Pipe-2-in-ABS-DWV-Hub-x-Spigot-22-1-2-Degree-Street-Elbow-Fitting-ABS003260800HD/313834674',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '2 in. ABS DWV MPT Cleanout Plug',
    brand: 'Charlotte Pipe',
    modelLinkName: 'ABS001060800HD',
    quantity: 5.0,
    unitCost: 3.97,
    totalCost: 19.85,
    modelLink:
      'https://www.homedepot.com/p/Charlotte-Pipe-2-in-ABS-DWV-MPT-Cleanout-Pug-ABS001060800HD/313834591',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '2 in. ABS DWV Long Sweep',
    brand: 'Charlotte Pipe',
    modelLinkName: 'ABS003040800HD',
    quantity: 8.0,
    unitCost: 7.64,
    totalCost: 61.12,
    modelLink:
      'https://www.homedepot.com/p/Charlotte-Pipe-2-in-ABS-DWV-Long-Sweep-ABS003040800HD/313834640',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '3 in. ABS DWV Long Sweep',
    brand: 'NIBCO',
    modelLinkName: 'C5892HD112114',
    quantity: 8.0,
    unitCost: 12.44,
    totalCost: 99.52,
    modelLink:
      'https://www.homedepot.com/p/NIBCO-1-1-2-in-x-1-1-4-in-ABS-DWV-Hub-x-Slip-Joint-P-Trap-C5892HD112114/100348236',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '1-1/2 in. x 24 in. ABS DWV Cell core Pipe',
    brand: 'IPEX',
    modelLinkName: '179694',
    quantity: 1.0,
    unitCost: 2.08,
    totalCost: 20.8,
    modelLink:
      'https://www.homedepot.com/p/IPEX-1-1-2-in-x-24-in-ABS-DWV-Cell-core-Pipe-179694/202300518?MERCH=REC-_-fbt_test-_-100348236-_-1-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '2 in. x 1-1/2 in. DWV Flexible PVC Coupling',
    brand: 'Fernco',
    modelLinkName: 'P1056-215',
    quantity: 8.0,
    unitCost: 6.56,
    totalCost: 52.48,
    modelLink:
      'https://www.homedepot.com/p/Fernco-2-in-x-1-1-2-in-DWV-Flexible-PVC-Coupling-P1056-215/100013986?MERCH=REC-_-fbt_test-_-100348236-_-4-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a',
  },
  {
    parentGroup: 'Plumbing',
    unitName: 'Reinforced Toilet Wax Ring',
    brand: 'Everbilt',
    modelLinkName: '4374',
    quantity: 5.0,
    unitCost: 6.98,
    totalCost: 34.900000000000006,
    modelLink:
      'https://www.homedepot.com/p/Everbilt-Extra-Thick-Reinforced-Toilet-Wax-Ring-with-Plastic-Horn-and-Zinc-Plated-Toilet-Bolts-4374/100211038',
  },
  {
    parentGroup: 'Plumbing',
    unitName: 'Hose Bibb Valve',
    brand: 'Everbilt',
    modelLinkName: 'VHNQTRF4EB',
    quantity: 5.0,
    unitCost: 14.43,
    totalCost: 72.15,
    modelLink:
      'https://www.homedepot.com/p/3-4-in-MIP-1-2-in-FIP-x-3-4-in-MHT-Quarter-Turn-Brass-No-Kink-Hose-Bibb-Valve-VHNQTRF4EB/205817688',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '3/4 in. x 1/2 in. Copper Pressure Cup x Female Adapter Fitting',
    brand: 'Everbilt',
    modelLinkName: 'C603HD3412',
    quantity: 5.0,
    unitCost: 10.71,
    totalCost: 53.550000000000004,
    modelLink:
      'https://www.homedepot.com/p/Everbilt-3-4-in-x-1-2-in-Copper-Pressure-Cup-x-Female-Adapter-Fitting-C603HD3412/100007956',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '3/4 in. Copper Pressure Slip Coupling Fitting',
    brand: 'Everbilt',
    modelLinkName: 'C601HD34',
    quantity: 50.0,
    unitCost: 2.96,
    totalCost: 148.0,
    modelLink:
      'https://www.homedepot.com/p/Everbilt-3-4-in-Copper-Pressure-Slip-Coupling-Fitting-C601HD34/100346736',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '3/4 in. Wrot Copper 90-Degree Cup x Cup Elbow Fitting',
    brand: 'Everbilt',
    modelLinkName: 'MPP607HD34',
    quantity: 75.0,
    unitCost: 1.12,
    totalCost: 84.00000000000001,
    modelLink:
      'https://www.homedepot.com/p/Everbilt-3-4-in-Wrot-Copper-90-Degree-Cup-x-Cup-Elbow-Fitting-Pro-Pack-25-Pack-MPP607HD34/302577470',
  },
  {
    parentGroup: 'Plumbing',
    unitName: 'Copper Air Chamber Fitting',
    brand: 'Everbilt',
    modelLinkName: 'C619HD1212',
    quantity: 10.0,
    unitCost: 20.13,
    totalCost: 201.29999999999998,
    modelLink:
      'https://www.homedepot.com/p/1-2-in-x-12-in-Copper-Air-Chamber-Fitting-C619HD1212/100677989',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '3/4 in. x 10 ft. Copper Type M Hard Temper Straight Pipe',
    brand: 'Cerro',
    modelLinkName: '3/4 M 10',
    quantity: 1.0,
    unitCost: 3.43,
    totalCost: 1715.0,
    modelLink:
      'https://www.homedepot.com/p/Cerro-3-4-in-x-10-ft-Copper-Type-M-Hard-Temper-Straight-Pipe-3-4-M-10/100354200',
  },
  {
    parentGroup: 'Plumbing',
    unitName: '2 in. Service Entrance (SE) Roof Flashing',
    brand: 'Halex',
    modelLinkName: '60820',
    quantity: 1.0,
    unitCost: 8.98,
    totalCost: 8.98,
    modelLink:
      'https://www.homedepot.com/p/Halex-2-in-Service-Entrance-SE-Roof-Flashing-60820/100209801',
  },
  {
    parentGroup: 'Plumbing',
    unitName: 'Gas - 3/4 in. x 10 ft. Black Steel Pipe',
    brand: 'Southland',
    modelLinkName: '584-1200HC',
    quantity: 1.0,
    unitCost: 2.75,
    totalCost: 110.0,
    modelLink:
      'https://www.homedepot.com/p/Southland-3-4-in-x-10-ft-Black-Steel-Pipe-584-1200HC/100540481',
  },
  {
    parentGroup: 'Plumbing',
    unitName: 'Indoor/Outdoor Tankless Water Heater',
    brand: 'Rinnai',
    modelLinkName: 'CX199iN',
    quantity: 2.0,
    unitCost: 1582.7,
    totalCost: 3165.4,
    modelLink:
      'https://www.homedepot.com/p/Rinnai-Sensei-11-1-GPM-Commercial-199-000-BTU-Propane-Natural-Gas-Indoor-Outdoor-Tankless-Water-Heater-CX199iN/329105122',
  },
  {
    parentGroup: 'Plumbing',
    unitName: 'Kitchen Sink - Undermount Single Bowl',
    brand: 'Kraus',
    modelLinkName: 'KHU100-32',
    quantity: 1.0,
    unitCost: 329.95,
    totalCost: 329.95,
    modelLink:
      'https://www.homedepot.com/p/KRAUS-Standart-PRO-32-in-Undermount-Single-Bowl-16-Gauge-Stainless-Steel-Kitchen-Sink-with-Accessories-KHU100-32/203058417',
  },
  {
    parentGroup: 'Plumbing',
    unitName: 'Kitchen Sink - Undermount Single Bowl',
    brand: 'Kraus',
    modelLinkName: 'KHU101-24L',
    quantity: 1.0,
    unitCost: 299.95,
    totalCost: 299.95,
    modelLink:
      'https://www.homedepot.com/p/KRAUS-Standart-PRO-24-Undermount-16-Gauge-Stainless-Steel-Single-Bowl-Laundry-Utility-Sink-KHU101-24L/313504951',
  },
  {
    parentGroup: 'Plumbing',
    unitName: 'Undermount Bathroom Sink',
    brand: 'Glacier Bay',
    modelLinkName: 'LVB1038',
    quantity: 6.0,
    unitCost: 53.55,
    totalCost: 321.29999999999995,
    modelLink:
      'https://www.homedepot.com/p/Glacier-Bay-22-in-Ceramic-Rectangular-Undermount-Bathroom-Sink-in-White-with-Overflow-Drain-LVB1038/322129849',
  },
  {
    parentGroup: 'Plumbing',
    unitName: 'Dual Flush Elongated Toilet in Glossy White',
    brand: 'Swiss Madison',
    modelLinkName: 'SM-1T254',
    quantity: 5.0,
    unitCost: 283.0,
    totalCost: 1415.0,
    modelLink:
      'https://www.homedepot.com/p/Swiss-Madison-St-Tropez-1-Piece-1-1-1-6-GPF-Dual-Flush-Elongated-Toilet-in-Glossy-White-SM-1T254/303338365',
  },
  {
    parentGroup: 'Plumbing',
    unitName: 'Round Wall Bar Shower Kit with Fixed Shower',
    brand: 'ARCORA',
    modelLinkName: 'AR9106000D',
    quantity: 5.0,
    unitCost: 129.9,
    totalCost: 649.5,
    modelLink:
      'https://www.homedepot.com/p/ARCORA-1-Spray-8-in-Round-Wall-Bar-Shower-Kit-with-Fixed-Shower-Head-and-Hand-Shower-in-Matte-Black-AR9106000D/331495269',
  },
  {
    parentGroup: 'Plumbing',
    unitName: 'Commercial Kitchen Faucet',
    brand: 'KRAUS',
    modelLinkName: 'KPF-1610SS',
    quantity: 2.0,
    unitCost: 159.95,
    totalCost: 319.9,
    modelLink:
      'https://www.homedepot.com/p/KRAUS-Bolden-Single-Handle-18-Inch-Commercial-Kitchen-Faucet-with-Dual-Function-Pull-Down-Sprayhead-in-Stainless-Steel-KPF-1610SS/303385525',
  },
  {
    parentGroup: 'Plumbing',
    unitName: 'Bathroom Sink Pop-Up Drain ',
    brand: 'VIGO',
    modelLinkName: 'VG16002MB',
    quantity: 7.0,
    unitCost: 44.9,
    totalCost: 314.3,
    modelLink:
      'https://www.homedepot.com/p/VIGO-Bathroom-Sink-Pop-Up-Drain-with-Overflow-in-Matte-Black-VG16002MB/307869050?MERCH=REC-_-fbt_test-_-306385181-_-1-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a',
  },
  {
    parentGroup: 'Plumbing',
    unitName: 'Single-Hole Bathroom Faucet in Matte Black',
    brand: 'VIGO',
    modelLinkName: 'VG01028MB',
    quantity: 1.0,
    unitCost: 129.9,
    totalCost: 129.9,
    modelLink:
      'https://www.homedepot.com/p/VIGO-Penela-Single-Handle-Single-Hole-Bathroom-Faucet-in-Matte-Black-VG01028MB/306385181',
  },
  {
    parentGroup: 'Mech',
    unitName: '3 in. x 8 ft. Semi-Rigid HP Expand Duct',
    brand: 'Everbilt',
    modelLinkName: 'EVER020',
    quantity: 8.0,
    unitCost: 14.28,
    totalCost: 114.24,
    modelLink:
      'https://www.homedepot.com/p/Everbilt-3-in-x-8-ft-Semi-Rigid-HP-Expand-Duct-EVER020/313119918?MERCH=REC-_-plpsearch_multi-_-317268962-_-4-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a',
  },
  {
    parentGroup: 'Mech',
    unitName: '3 in. 90 Deg. Round Adjustable Elbow',
    brand: 'Master Flow',
    modelLinkName: 'B90E3',
    quantity: 7.0,
    unitCost: 6.58,
    totalCost: 46.06,
    modelLink:
      'https://www.homedepot.com/p/Master-Flow-3-in-90-Deg-Round-Adjustable-Elbow-B90E3/100112500?MERCH=REC-_-fbt_test-_-313119918-_-3-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a',
  },
  {
    parentGroup: 'Mech',
    unitName: '3 in. to 4 in. Adjustable Worm Clamps',
    brand: 'Everbilt',
    modelLinkName: 'MC34RHD',
    quantity: 16.0,
    unitCost: 2.76,
    totalCost: 44.16,
    modelLink:
      'https://www.homedepot.com/p/Everbilt-3-in-to-4-in-Adjustable-Worm-Clamps-MC34RHD/313684998?MERCH=REC-_-fbt_test-_-313119918-_-1-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a',
  },
  {
    parentGroup: 'Mech',
    unitName: 'Wide Mouth Dryer Vent Hood in White',
    brand: 'Everbilt',
    modelLinkName: 'BPMH4WHD6',
    quantity: 1.0,
    unitCost: 17.98,
    totalCost: 17.98,
    modelLink:
      'https://www.homedepot.com/p/Everbilt-Wide-Mouth-Dryer-Vent-Hood-in-White-BPMH4WHD6/203647465?MERCH=REC-_-fbr-_-313119918-_-1-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a',
  },
  {
    parentGroup: 'Mech',
    unitName: '4 in. Goose Neck Vent Roof Cap in Black',
    brand: 'Master Flow',
    modelLinkName: 'GNV4BL',
    quantity: 8.0,
    unitCost: 42.68,
    totalCost: 341.44,
    modelLink:
      'https://www.homedepot.com/p/Master-Flow-4-in-Goose-Neck-Vent-Roof-Cap-in-Black-GNV4BL/100396945',
  },
  {
    parentGroup: 'Mech',
    unitName:
      'Whisper Cozy DC 80/110 CFM Pick-A-Flow Ceiling Bathroom Exhaust Fan/Heater ',
    brand: 'Panasonic',
    modelLinkName: 'RG-Z811A',
    quantity: 5.0,
    unitCost: 279.0,
    totalCost: 1395.0,
    modelLink:
      'https://www.homedepot.com/p/Panasonic-Whisper-Cozy-DC-80-110-CFM-Pick-A-Flow-Ceiling-Bathroom-Exhaust-Fan-Heater-with-Flex-Z-Fast-Easy-Install-Bracket-RG-Z811A/328987518',
  },
  {
    parentGroup: 'Mech',
    unitName: '10 in. x 6 in. 3-Way Steel Wall/Ceiling Register in White',
    brand: 'Everbilt',
    modelLinkName: 'E103M10X06',
    quantity: 7.0,
    unitCost: 14.67,
    totalCost: 102.69,
    modelLink:
      'https://www.homedepot.com/p/Everbilt-10-in-x-6-in-3-Way-Steel-Wall-Ceiling-Register-in-White-E103M10X06/300539156',
  },
  {
    parentGroup: 'Mech',
    unitName: 'WhisperSense DC Fan with Motion and Humidity Sensors',
    brand: 'Panasonic',
    modelLinkName: 'FV-0511VQC1',
    quantity: 2.0,
    unitCost: 213.99,
    totalCost: 427.98,
    modelLink:
      'https://www.homedepot.com/p/Panasonic-WhisperSense-DC-Fan-with-Motion-and-Humidity-Sensors-Delay-Timer-and-Pick-A-Flow-Speed-Selector-50-80-or-110-CFM-FV-0511VQC1/303688953',
  },
  {
    parentGroup: 'Mech',
    unitName: 'HVAC Cassette',
    brand: 'Fujitsu',
    modelLinkName: 'AUUA24TLAV2',
    quantity: 5.0,
    unitCost: 3548.0,
    totalCost: 17740.0,
    modelLink:
      'https://www.fujitsu-general.com/us/products/vrf/indoor/cassette/auua-grid.html',
  },
  {
    parentGroup: 'Mech',
    unitName: 'Outdoor Heat pump unit',
    brand: 'Fujitsu',
    modelLinkName: 'AOU60RLAVM',
    quantity: 1.0,
    unitCost: 4269.0,
    totalCost: 4269.0,
    modelLink:
      'https://www.fujitsu-general.com/us/products/vrf/j4/aou60rlavm4.html',
  },
  {
    parentGroup: 'Mech',
    unitName: '6 in. x 25 ft. Insulated Flexible Duct R8 Silver Jacket',
    brand: 'Master Flow',
    modelLinkName: 'F8IFD6X300',
    quantity: 2.0,
    unitCost: 54.68,
    totalCost: 109.36,
    modelLink:
      'https://www.homedepot.com/p/Master-Flow-6-in-x-25-ft-Insulated-Flexible-Duct-R8-Silver-Jacket-Pack-of-6-F8IFD6X300-6PK/313280499',
  },
  {
    parentGroup: 'Mech',
    unitName: '4 in. x 25 ft. Insulated Flexible Duct R8 Silver Jacket',
    brand: 'Master Flow',
    modelLinkName: 'F8IFD4X300',
    quantity: 1.0,
    unitCost: 41.48,
    totalCost: 41.48,
    modelLink:
      'https://www.homedepot.com/p/Master-Flow-4-in-x-25-ft-Insulated-Flexible-Duct-R8-Silver-Jacket-Pack-of-6-F8IFD4X300-6PK/313316118',
  },
  {
    parentGroup: 'Mech',
    unitName: '10 in. x 25 ft. Insulated Flexible Duct R8 Silver Jacket',
    brand: 'Master Flow',
    modelLinkName: 'F8IFD10X300',
    quantity: 2.0,
    unitCost: 65.15,
    totalCost: 130.3,
    modelLink:
      'https://www.homedepot.com/p/Master-Flow-10-in-x-25-ft-Insulated-Flexible-Duct-R8-Silver-Jacket-Pack-of-6-F8IFD10X300-6PK/313316149',
  },
  {
    parentGroup: 'Mech',
    unitName:
      'Fujitsu - 48k BTU Cooling + Heating - Multi-Position Air Handler System',
    brand: 'Fujitsu',
    modelLinkName: '48LMAS1',
    quantity: 1.0,
    unitCost: 6622.45,
    totalCost: 6622.45,
    modelLink:
      'http://ecomfort.com/Fujitsu-48LMAS1/p109267.html?srsltid=AfmBOoqo3ciM438RMrL0u68qOVuUsGseocXjb0bFPjx09TzTZJbq5nOj5Q8',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Wall Tile - Concept Gray Polished Porcelain Tile',
    brand: 'Pianello',
    modelLinkName: '101075281',
    quantity: 1.15,
    unitCost: 3.88,
    totalCost: 108.38197999999998,
    modelLink:
      'https://www.flooranddecor.com/porcelain-tile/concept-gray-polished-porcelain-tile-101075281.html',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Wall Tile - Concept Gray Polished Porcelain Tile',
    brand: 'Pianello',
    modelLinkName: '101075281',
    quantity: 1.15,
    unitCost: 3.88,
    totalCost: 106.68641999999998,
    modelLink:
      'https://www.flooranddecor.com/porcelain-tile/concept-gray-polished-porcelain-tile-101075281.html',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Wall Tile - Concept Gray Polished Porcelain Tile',
    brand: 'Pianello',
    modelLinkName: '101075281',
    quantity: 1.15,
    unitCost: 3.88,
    totalCost: 178.48,
    modelLink:
      'https://www.flooranddecor.com/porcelain-tile/concept-gray-polished-porcelain-tile-101075281.html',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Wall Tile - Concept Gray Polished Porcelain Tile',
    brand: 'Pianello',
    modelLinkName: '101075281',
    quantity: 1.15,
    unitCost: 3.88,
    totalCost: 388.68481999999995,
    modelLink:
      'https://www.flooranddecor.com/porcelain-tile/concept-gray-polished-porcelain-tile-101075281.html',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Wall Tile - Concept Gray Polished Porcelain Tile',
    brand: 'Pianello',
    modelLinkName: '101075281',
    quantity: 1.15,
    unitCost: 3.88,
    totalCost: 213.77441999999996,
    modelLink:
      'https://www.flooranddecor.com/porcelain-tile/concept-gray-polished-porcelain-tile-101075281.html',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Wall Tile - Concept Gray Polished Porcelain Tile',
    brand: 'Pianello',
    modelLinkName: '101075281',
    quantity: 1.15,
    unitCost: 3.88,
    totalCost: 106.37407999999998,
    modelLink:
      'https://www.flooranddecor.com/porcelain-tile/concept-gray-polished-porcelain-tile-101075281.html',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Wall Tile - Concept Gray Polished Porcelain Tile',
    brand: 'Pianello',
    modelLinkName: '101075281',
    quantity: 1.15,
    unitCost: 3.88,
    totalCost: 134.44006,
    modelLink:
      'https://www.flooranddecor.com/porcelain-tile/concept-gray-polished-porcelain-tile-101075281.html',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Wall Tile - Lotus White Matte Porcelain Tile',
    brand: 'Floor decor',
    modelLinkName: '100593573',
    quantity: 1.15,
    unitCost: 3.99,
    totalCost: 111.45466499999999,
    modelLink:
      'https://www.flooranddecor.com/porcelain-tile/lotus-white-matte-porcelain-tile-100593573.html',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Wall Tile - Lotus White Matte Porcelain Tile',
    brand: 'Floor decor',
    modelLinkName: '100593573',
    quantity: 1.15,
    unitCost: 3.99,
    totalCost: 110.261655,
    modelLink:
      'https://www.flooranddecor.com/porcelain-tile/lotus-white-matte-porcelain-tile-100593573.html',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Wall Tile - Lotus White Matte Porcelain Tile',
    brand: 'Floor decor',
    modelLinkName: '100593573',
    quantity: 1.15,
    unitCost: 3.99,
    totalCost: 135.68194499999998,
    modelLink:
      'https://www.flooranddecor.com/porcelain-tile/lotus-white-matte-porcelain-tile-100593573.html',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Wall Tile - Lotus White Matte Porcelain Tile',
    brand: 'Floor decor',
    modelLinkName: '100593573',
    quantity: 1.15,
    unitCost: 3.99,
    totalCost: 105.030765,
    modelLink:
      'https://www.flooranddecor.com/porcelain-tile/lotus-white-matte-porcelain-tile-100593573.html',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Wall Tile - Lotus White Matte Porcelain Tile',
    brand: 'Floor decor',
    modelLinkName: '100593573',
    quantity: 1.15,
    unitCost: 3.99,
    totalCost: 106.08612,
    modelLink:
      'https://www.flooranddecor.com/porcelain-tile/lotus-white-matte-porcelain-tile-100593573.html',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Floor Tile - District Gray Porcelain Tile',
    brand: 'Floor decor',
    modelLinkName: '100785070',
    quantity: 1.15,
    unitCost: 3.96,
    totalCost: 310.7649599999999,
    modelLink:
      'https://www.flooranddecor.com/s/floor-decor/porcelain-tile/district-gray-porcelain-tile-100785070.html',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Carpet - Bedroom 1',
    brand: 'Home Decorators Collection',
    modelLinkName: 'H2019-792-1200',
    quantity: 1.15,
    unitCost: 2.62,
    totalCost: 512.3606500000001,
    modelLink:
      'https://www.homedepot.com/p/Home-Decorators-Collection-Clareview-Eastglen-Gray-12-ft-Wide-x-Cut-to-Length-46-oz-SD-Polyester-Texture-Carpet-H2019-792-1200/300824675',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Carpet - Bedroom 2',
    brand: 'Home Decorators Collection',
    modelLinkName: 'H2019-792-1201',
    quantity: 1.15,
    unitCost: 2.62,
    totalCost: 548.33587,
    modelLink:
      'https://www.homedepot.com/p/Home-Decorators-Collection-Clareview-Eastglen-Gray-12-ft-Wide-x-Cut-to-Length-46-oz-SD-Polyester-Texture-Carpet-H2019-792-1200/300824675',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Hardwood Flooring - Select Red Oak 3/4 in',
    brand: 'Home Depot',
    modelLinkName: 'SRO2.25',
    quantity: 1.15,
    unitCost: 5.86,
    totalCost: 5103.2425299999995,
    modelLink:
      'https://www.homedepot.com/p/Select-Red-Oak-3-4-in-Thick-x-2-1-4-in-Wide-x-Random-Length-Solid-Hardwood-Flooring-19-5-sqft-case-SRO2-25/202864697',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Floor Tile - District Gray Porcelain Tile',
    brand: '',
    modelLinkName: '100593573',
    quantity: 1.15,
    unitCost: 3.96,
    totalCost: 411.54498,
    modelLink:
      'https://www.flooranddecor.com/porcelain-tile/lotus-white-matte-porcelain-tile-100593573.html',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Kitchen Backsplash - Restore Bright White',
    brand: 'Daltile',
    modelLinkName: 'RE1524BWHD1P2',
    quantity: 1.15,
    unitCost: 3.98,
    totalCost: 70.0281,
    modelLink:
      'https://www.homedepot.com/p/Daltile-Restore-Bright-White-12-in-x-12-in-x-6-35-mm-Ceramic-Mosaic-Wall-Tile-0-83-sq-ft-Each-RE1524BWHD1P2/302602963',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Laundry Backsplash - Restore Bright White',
    brand: 'Daltile',
    modelLinkName: 'RE1524BWHD1P3',
    quantity: 1.15,
    unitCost: 3.98,
    totalCost: 274.62,
    modelLink: '',
  },
  {
    parentGroup: 'Hardwood / Stone',
    unitName: 'Kitchen Quartz Countertop',
    brand: 'Caesarstone',
    modelLinkName: '5151 Empira White',
    quantity: 1.15,
    unitCost: 75.0,
    totalCost: 6341.099999999999,
    modelLink: '',
  },
  {
    parentGroup: 'Cladding',
    unitName: 'Stucco',
    brand: '',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 0.0,
    totalCost: 0.0,
    modelLink: '',
  },
  {
    parentGroup: 'Cladding',
    unitName: 'Thermally Modified Wood Siding Board',
    brand: 'Thermory',
    modelLinkName: '11154-8',
    quantity: 1.15,
    unitCost: 12.11,
    totalCost: 24735.831505,
    modelLink: '',
  },
  {
    parentGroup: 'Cladding',
    unitName: 'Thermally Black Smooth Pine',
    brand: 'Thermory',
    modelLinkName: '345606',
    quantity: 1.15,
    unitCost: 12.11,
    totalCost: 2720.1239799999994,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W1',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 1187.66,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W2',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 1200.5600000000002,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W3',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 847.1,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W4',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 829.9,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W5',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 83.42,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W6',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 823.88,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W7',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 3769.3799999999997,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W8',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 4558.86,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W9',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 866.88,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W10',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 3550.08,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W11',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 1035.4399999999998,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W12',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 80.83999999999999,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W13',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 2640.2,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W14',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 2691.8,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W15',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 3472.6800000000003,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W16',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 468.7,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W17',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 933.1,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W18',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 1684.74,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W19',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 1241.84,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W20',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 699.1800000000001,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W21',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 743.9,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W22',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 5282.12,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W23',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 456.65999999999997,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W24',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 595.98,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W25',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 785.1800000000001,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W26',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 2856.92,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W27',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 2983.3399999999997,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W28',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 2985.06,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W29',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 3650.7000000000003,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W30',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 746.48,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W31',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 5287.28,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W32',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 1670.1200000000001,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W33',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 2144.84,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Windows W34',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 760.24,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Exterior doors',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 2738.24,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Exterior doors',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 12058.92,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Exterior doors',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 86.0,
    totalCost: 6076.759999999999,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Attic Door',
    brand: 'Master Flow',
    modelLinkName: 'MAD24X48',
    quantity: 1.0,
    unitCost: 122.99,
    totalCost: 122.99,
    modelLink:
      'https://www.homedepot.com/p/Master-Flow-24-in-x-48-in-Maintenance-Access-Door-MAD24X48/202865543',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName:
      'Fresh Air Venting Curb-Mount Skylight with Laminated Low-E3 Glass',
    brand: 'Velux',
    modelLinkName: 'VCM 2246 2004',
    quantity: 8.0,
    unitCost: 719.0,
    totalCost: 5752.0,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Interior doors - Oak - Left swing',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 1.0,
    unitCost: 550.0,
    totalCost: 550.0,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Interior doors - Closet',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 2.0,
    unitCost: 550.0,
    totalCost: 1100.0,
    modelLink: '',
  },
  {
    parentGroup: 'Windows / Doors',
    unitName: 'Interior doors - Oak - Right swing',
    brand: 'Neovi',
    modelLinkName: '',
    quantity: 19.0,
    unitCost: 550.0,
    totalCost: 10450.0,
    modelLink: '',
  },
  {
    parentGroup: 'Exterior Other',
    unitName:
      'Flood Vents - Wall Flood Vent 14.5-in x 8.5-in Steel Foundation Vent',
    brand: 'SMART VENT',
    modelLinkName: '1540-570 GRAY',
    quantity: 7.0,
    unitCost: 244.99,
    totalCost: 1714.93,
    modelLink:
      'https://www.lowes.com/pd/SMART-VENT-Wood-Wall-Flood-Vent-14-5-in-x-8-5-in-Steel-Foundation-Vent/5013487521?user=shopping&feed=yes&srsltid=AfmBOopCtO1o4fLgROZdDE1riGUFYdmo853UCp7ZQ6dMjuVDLPovXH1M9JI&com_cvv=8fb3d522dc163aeadb66e08cd7450cbbdddc64c6cf2e8891f6d48747c6d56d2c',
  },
  {
    parentGroup: 'Building Supply',
    unitName: 'Black Aluminum K-Style Gutter',
    brand: 'Amerimax Home Products',
    modelLinkName: '2400635120',
    quantity: 1.15,
    unitCost: 1.3,
    totalCost: 673.45265,
    modelLink:
      'https://www.homedepot.com/p/Amerimax-Home-Products-5-in-x-10-ft-Black-Aluminum-K-Style-Gutter-2400635120/323832638',
  },
  {
    parentGroup: 'Building Supply',
    unitName: 'Black Aluminum Downspout',
    brand: '',
    modelLinkName: '',
    quantity: 30.0,
    unitCost: 25.9,
    totalCost: 777.0,
    modelLink: '',
  },
  {
    parentGroup: 'Building Supply',
    unitName: 'R-38 Faced Fiberglass Insulation Batt 24 in. x 48 in',
    brand: 'Owens Corning',
    modelLinkName: 'E57',
    quantity: 1.15,
    unitCost: 2.13,
    totalCost: 9978.871079999999,
    modelLink:
      'https://www.homedepot.com/p/Owens-Corning-R-38-Faced-Fiberglass-Insulation-Batt-24-in-x-48-in-1-Bag-E57/100320292',
  },
  {
    parentGroup: 'Building Supply',
    unitName: 'R-21 Unfaced Fiberglass Insulation Batt 15 in. x 93 in.',
    brand: 'Owens Corning',
    modelLinkName: 'U98B',
    quantity: 1.15,
    unitCost: 1.2,
    totalCost: 5621.8992,
    modelLink:
      'https://www.homedepot.com/p/Owens-Corning-R-21-Unfaced-Fiberglass-Insulation-Batt-15-in-x-93-in-1-Bag-U89B/202563257',
  },
  {
    parentGroup: 'Building Supply',
    unitName:
      'R15 Thermafiber Fire and Sound Guard Plus Mineral Wool Insulation',
    brand: 'Owens Corning',
    modelLinkName: '1196590',
    quantity: 1.15,
    unitCost: 1.66,
    totalCost: 5098.938999999999,
    modelLink:
      'https://www.homedepot.com/p/Owens-Corning-15-in-x-47-in-R15-Thermafiber-Fire-and-Sound-Guard-Plus-Mineral-Wool-Insulation-Batt-1196590/319880538',
  },
  {
    parentGroup: 'Building Supply',
    unitName: 'High Definition Shingles',
    brand: 'GAF',
    modelLinkName: '489180',
    quantity: 1.15,
    unitCost: 1.22,
    totalCost: 5715.59752,
    modelLink:
      'https://www.homedepot.com/p/GAF-Timberline-HDZ-Charcoal-Algae-Resistant-Laminated-High-Definition-Shingles-33-33-sq-ft-per-Bundle-0489180/309755006',
  },
  {
    parentGroup: 'Building Supply',
    unitName: '5/8 Sheetrock',
    brand: 'USG Sheetrock Brand',
    modelLinkName: '14211011310',
    quantity: 1.15,
    unitCost: 0.51,
    totalCost: 3053.319,
    modelLink:
      'https://www.homedepot.com/p/USG-Sheetrock-Brand-5-8-in-x-4-ft-x-10-ft-Firecode-X-Drywall-14211011310/202329691',
  },
  {
    parentGroup: 'Building Supply',
    unitName: '1/2 Sheetrock',
    brand: 'Gold Bond',
    modelLinkName: '50000134',
    quantity: 1.15,
    unitCost: 0.42,
    totalCost: 157.458,
    modelLink:
      'https://www.homedepot.com/p/Gold-Bond-High-Strength-Lite-1-2-in-x-4-ft-x-12-ft-Lightweight-Drywall-Sheet-50000134/202809543',
  },
  {
    parentGroup: 'Building Supply',
    unitName: '2 in. x 6 in. x 10 ft. #2 Premium Grade Fir Dimensional Lumber',
    brand: 'Home Depot',
    modelLinkName: 'HCF-KDDF-PRIME-2x6x10',
    quantity: 1.15,
    unitCost: 9.34,
    totalCost: 6981.649999999999,
    modelLink:
      'https://www.homedepot.com/p/2-in-x-6-in-x-10-ft-2-Premium-Grade-Fir-Dimensional-Lumber-HCF-KDDF-PRIME-2x6x10/206804069',
  },
  {
    parentGroup: 'Building Supply',
    unitName: '2 in. x 12 in. x 20 ft. #2 Premium Grade Fir Dimensional Lumber',
    brand: 'Home Depot',
    modelLinkName: '714771',
    quantity: 2.15,
    unitCost: 41.32,
    totalCost: 13325.7,
    modelLink:
      'https://www.homedepot.com/p/2-in-x-12-in-x-20-ft-2-Premium-Grade-Fir-Dimensional-Lumber-714771/202094204',
  },
  {
    parentGroup: 'Building Supply',
    unitName: '3 in. x 12 in. x 20 ft. #2 Premium Grade Fir Dimensional Lumber',
    brand: 'Home Depot',
    modelLinkName: '714771',
    quantity: 1.15,
    unitCost: 41.32,
    totalCost: 5226.98,
    modelLink:
      'https://www.homedepot.com/p/2-in-x-12-in-x-20-ft-2-Premium-Grade-Fir-Dimensional-Lumber-714771/202094204',
  },
  {
    parentGroup: 'Building Supply',
    unitName: '2 in. x 6 in. x 10 ft. #2 Premium Grade Fir Dimensional Lumber',
    brand: 'Home Depot',
    modelLinkName: 'HCF-KDDF-PRIME-2x6x10',
    quantity: 1.15,
    unitCost: 9.34,
    totalCost: 10343.582999999999,
    modelLink:
      'https://www.homedepot.com/p/2-in-x-6-in-x-10-ft-2-Premium-Grade-Fir-Dimensional-Lumber-HCF-KDDF-PRIME-2x6x10/206804069',
  },
  {
    parentGroup: 'Building Supply',
    unitName: '4 in. x 6 in. x 12 ft. #2 Premium Grade Fir Dimensional Lumber',
    brand: 'Home Depot',
    modelLinkName: '441619',
    quantity: 30.0,
    unitCost: 25.26,
    totalCost: 757.8000000000001,
    modelLink:
      'https://www.homedepot.com/p/4-in-x-6-in-x-12-ft-2-Premium-Grade-Fir-Dimensional-Lumber-441619/202094372',
  },
  {
    parentGroup: 'Cabinets / Vanities',
    unitName: 'Cabinets',
    brand: 'Greenberg',
    modelLinkName: 'Bentwood',
    quantity: 1.0,
    unitCost: 550.0,
    totalCost: 63761.49999999999,
    modelLink: '',
  },
  {
    parentGroup: 'Cabinets / Vanities',
    unitName:
      '36 in. Single Sink Weathered Tan Bath Vanity with White Engineered Stone Top',
    brand: 'Home Decorators Collection',
    modelLinkName: 'Autumn 36WT',
    quantity: 4.0,
    unitCost: 449.0,
    totalCost: 1796.0,
    modelLink:
      'https://www.homedepot.com/p/Home-Decorators-Collection-Autumn-36-in-Single-Sink-Weathered-Tan-Bath-Vanity-with-White-Engineered-Stone-Top-Assembled-Autumn-36WT/324252471',
  },
  {
    parentGroup: 'Cabinets / Vanities',
    unitName:
      '60 in. Double Sink Freestanding Weathered Tan Bath Vanity with White Engineered Marble Top',
    brand: 'Home Decorators Collection',
    modelLinkName: 'Doveton 60WT',
    quantity: 1.0,
    unitCost: 899.0,
    totalCost: 899.0,
    modelLink:
      'https://www.homedepot.com/p/Home-Decorators-Collection-Doveton-60-in-Double-Sink-Freestanding-Weathered-Tan-Bath-Vanity-with-White-Engineered-Marble-Top-Assembled-Doveton-60WT/321491136',
  },
  {
    parentGroup: 'Cabinets / Vanities',
    unitName: 'Bookshelf',
    brand: 'Greenberg',
    modelLinkName: 'Bentwood',
    quantity: 1.0,
    unitCost: 550.0,
    totalCost: 44000.0,
    modelLink: '',
  },
  {
    parentGroup: 'Applainces',
    unitName: 'Electric Fireplace',
    brand: 'Karl home',
    modelLinkName: '886448832393',
    quantity: 1.0,
    unitCost: 190.0,
    totalCost: 190.0,
    modelLink:
      'https://www.homedepot.com/p/Karl-home-50-in-Wall-Mount-Insert-Freestanding-12-Color-Flames-Electric-Fireplace-with-Remote-Control-and-WIFI-Function-886448832393/319694732',
  },
  {
    parentGroup: 'Applainces',
    unitName: '36 in. Ducted Wall Mount Range Hood in Stainless Steel',
    brand: 'Cosmo',
    modelLinkName: 'COS-63190S',
    quantity: 2.0,
    unitCost: 216.39,
    totalCost: 432.78,
    modelLink:
      'https://www.homedepot.com/p/Cosmo-36-in-Ducted-Wall-Mount-Range-Hood-in-Stainless-Steel-with-Touch-Controls-LED-Lighting-and-Permanent-Filters-COS-63190S/207084054',
  },
  {
    parentGroup: 'Applainces',
    unitName: '30 in. Single Electric Wall Oven in Stainless Steel',
    brand: 'Samsung',
    modelLinkName: 'NV51T5511SS',
    quantity: 1.0,
    unitCost: 1098.0,
    totalCost: 1098.0,
    modelLink:
      'https://www.homedepot.com/p/Samsung-30-in-Single-Electric-Wall-Oven-in-Stainless-Steel-NV51T5511SS/312457139',
  },
  {
    parentGroup: 'Applainces',
    unitName: 'Microwave Drawer in Stainless Steel',
    brand: 'Sharp',
    modelLinkName: 'SMD2489ES',
    quantity: 1.0,
    unitCost: 1499.0,
    totalCost: 1499.0,
    modelLink:
      'https://www.homedepot.com/p/Sharp-1-2-cu-ft-Microwave-Drawer-in-Stainless-Steel-SMD2489ES/312482370',
  },
  {
    parentGroup: 'Applainces',
    unitName: 'Dishwasher with Adjustable Rack in Stainless Steel',
    brand: 'Samsung',
    modelLinkName: 'DW80CG4021SR',
    quantity: 1.0,
    unitCost: 378.0,
    totalCost: 378.0,
    modelLink:
      'https://www.homedepot.com/p/Samsung-Fingerprint-Resistant-53-dBA-Dishwasher-with-Adjustable-Rack-in-Stainless-Steel-DW80CG4021SR/325532197',
  },
  {
    parentGroup: 'Applainces',
    unitName: 'Radiant Electric Cooktop in Black with 5-Burner',
    brand: 'Samsung',
    modelLinkName: 'NZ36R5330RK',
    quantity: 1.0,
    unitCost: 698.0,
    totalCost: 698.0,
    modelLink:
      'https://www.homedepot.com/p/Samsung-36-in-Radiant-Electric-Cooktop-in-Black-with-5-Burner-Elements-NZ36R5330RK/311525994',
  },
  {
    parentGroup: 'Applainces',
    unitName: 'Garbage Disposal with Power Cord',
    brand: 'Glacier Bay',
    modelLinkName: '10-US-GB1000-SL',
    quantity: 1.0,
    unitCost: 179.0,
    totalCost: 179.0,
    modelLink:
      'https://www.homedepot.com/p/Glacier-Bay-TurboGrind-Max-1-hp-Continuous-Feed-Garbage-Disposal-with-Power-Cord-10-US-GB1000-SL/324538076',
  },
  {
    parentGroup: 'Applainces',
    unitName: 'French Door Refrigerator',
    brand: 'Samsung',
    modelLinkName: 'RF31CG7400SR',
    quantity: 1.0,
    unitCost: 2428.0,
    totalCost: 2428.0,
    modelLink:
      'https://www.homedepot.com/p/Samsung-30-cu-ft-Mega-Capacity-4-Door-French-Door-Refrigerator-with-Four-Types-of-Ice-in-Stainless-Steel-RF31CG7400SR/326195098',
  },
  {
    parentGroup: 'Hardscaping',
    unitName: 'Deck - Thermally Modified Wood ',
    brand: 'Thermory',
    modelLinkName: '11154-8',
    quantity: 1.15,
    unitCost: 12.11,
    totalCost: 3203.095,
    modelLink: '',
  },
  {
    parentGroup: 'Hardscaping',
    unitName: 'Rectangle Concrete Paver',
    brand: 'Basalite',
    modelLinkName: '100002937',
    quantity: 1.0,
    unitCost: 0.68,
    totalCost: 792.5740000000001,
    modelLink:
      'https://www.homedepot.com/p/Basalite-Holland-4-in-x-8-in-Tan-Brown-Rectangle-Concrete-Paver-100002937/100135839',
  },
  {
    parentGroup: 'Other',
    unitName: 'Bath Hardware Set ',
    brand: 'Delta',
    modelLinkName: 'PWD63-MB-VK',
    quantity: 5.0,
    unitCost: 89.1,
    totalCost: 445.5,
    modelLink:
      'https://www.homedepot.com/p/Delta-Portwood-3-Piece-Bath-Hardware-Set-with-24-in-Towel-Bar-Toilet-Paper-Holder-Towel-Ring-in-Matte-Black-PWD63-MB-VK/329188844',
  },
  {
    parentGroup: 'Other',
    unitName: 'Rectangular Framed Wall Bathroom Vanity Mirror',
    brand: 'niveal',
    modelLinkName: 'SM-4836MB',
    quantity: 7.0,
    unitCost: 199.0,
    totalCost: 1393.0,
    modelLink: '',
  },
  {
    parentGroup: 'Other',
    unitName: 'Keyed Door Knob Lock Set',
    brand: 'Kwikset',
    modelLinkName: '730PSK SQT 514',
    quantity: 20.0,
    unitCost: 24.97,
    totalCost: 499.4,
    modelLink:
      'https://www.homedepot.com/p/Kwikset-Pismo-Square-Matte-Black-Privacy-Bed-Bath-Door-Knob-with-Lock-730PSK-SQT-514/312380007',
  },
]

interface TakeOffState {
  selectedAreasIds: string[]
  itemList: TakeOffItem[]
  isItemListPresented: boolean
  isTakeOffCalculationInProgress: boolean
  takeOffCalculations: TakeOffCalculation | null
}

const initialState: TakeOffState = {
  selectedAreasIds: [],
  itemList: takeOffItemsMock,
  isItemListPresented: false,
  isTakeOffCalculationInProgress: false,
  takeOffCalculations: null,
}

const takeOffReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(showItemList, (state, action) => {
      state.isItemListPresented = action.payload
    })
    .addCase(selectAreas, (state, action) => {
      const selectedAreasIds = new Set([
        ...state.selectedAreasIds,
        ...action.payload.areasIds,
      ])

      state.selectedAreasIds = Array.from(selectedAreasIds)
    })
    .addCase(deselectAreas, (state, action) => {
      const selectedAreasIds = new Set(state.selectedAreasIds)
      action.payload.areasIds.forEach((roomId) => {
        selectedAreasIds.delete(roomId)
      })

      state.selectedAreasIds = Array.from(selectedAreasIds)
    })
    .addCase(setItemList, (state, action) => {
      state.itemList = action.payload.items
    })
    .addCase(setIsTakeOffCalculationInProgress, (state, action) => {
      state.isTakeOffCalculationInProgress = action.payload
    })
    .addCase(updateTakeOffCalculation, (state, action) => {
      state.takeOffCalculations = action.payload
    })
})

export default takeOffReducer
